
export const ImgZoom = {
    bind(el, binding, vnode) {
        $(el).magnificPopup({
            type: 'image',
            items: {
                src: $(el).attr('src')
            },
        });
    },
};
